
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import FormModel, { FormModelField } from '@/repositories/data/FormModel';
import FileUploader from '@/components/FileUploader.vue';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import FormModelEmbed from '@/components/FormModelEmbed.vue';
import OrderingForm from '@/components/OrderingForm.vue';
import mavonEditor from 'mavon-editor';
import VueCurrencyInput from 'vue-currency-input';
import 'mavon-editor/dist/css/index.css';
import NgtFilmSelector from '@/components/NgtFilmSelector.vue';
import { FormPresence } from '@/repositories/FormPresence';
import MultiSourceVideoSelector from '@/components/MultiSourceVideoSelector.vue';

const currencyOptions = {
    globalOptions: {
        currency: 'EUR',
    },
};

Vue.use(mavonEditor);
Vue.use(VueCurrencyInput, currencyOptions);
@Component({
    components: {
        MultiSourceVideoSelector,
        NgtFilmSelector,
        OrderingForm,
        FileUploader,
        FormModelEmbed,
    },
})
export default class FormModelForm extends Vue {
    @Prop({ type: Object, required: true })
    private readonly entityRepository!: BaseCrudRepository<any, any, any>;

    @Prop({ type: String, required: true })
    public readonly i18nGroup!: string;

    @Prop({ type: Boolean, required: false, default: true })
    public readonly loading!: boolean;

    @Prop({ type: Object, required: false, default: () => new FormModel([]) })
    public readonly formModel!: FormModel;

    @Prop({ type: Array, required: false, default: () => [] })
    public readonly embeds!: EmbeddedForm[];

    public modal: { key: string; value: boolean } = {} as { key: string; value: boolean };

    private findEmbeddedFormData(embedType: string): EmbeddedForm | null {
        const relationship = embedType.substring('embed:'.length);
        const result = this.embeds.find((t) => t.relationship === relationship);
        return result ? result : null;
    }

    private onError(error: any) {
        this.$emit('error', error);
    }

    public isVisible(field: FormModelField, model: FormModel) {
        if (!field.visible) {
            return false;
        } else {
            switch (field.presence) {
                case FormPresence.ALL:
                    return true;
                case FormPresence.CREATE:
                    return model.isNew;
                case FormPresence.UPDATE:
                    return !model.isNew;
            }
        }
    }

    public hasVisibleField(fields: FormModelField[], model: FormModel): boolean {
        for (let field of fields) {
            if (this.isVisible(field, model)) {
                return true;
            }
        }
        return false;
    }

    public get mavonToolbars() {
        return {
            bold: true,
            italic: true,
            header: true,
            underline: true,
            strikethrough: true,
            mark: true,
            superscript: true,
            subscript: true,
            quote: true,
            ol: true,
            ul: true,
            link: true,
            imagelink: false,
            code: true,
            table: true,
            undo: true,
            redo: true,
            trash: false,
            save: false,
            alignleft: true,
            aligncenter: true,
            alignright: true,
            navigation: true,
            subfield: true,
            fullscreen: true,
            readmodel: true,
            htmlcode: true,
            help: true,
            preview: true,
        };
    }
}
